import {inject, Pipe, PipeTransform} from '@angular/core';
import {NumberMappingService} from 'src/app/services/mapping/number-mapping/number-mapping.service';
import {TagValueDisplayType} from 'src/app/bfa-api/models/tag-value-display-type';

@Pipe({
    name: 'tagNumberDisplay',
    standalone: true
})
export class TagNumberDisplayPipe implements PipeTransform {
    private readonly numberMappingService: NumberMappingService = inject(NumberMappingService);

    public transform(
        value: string | null | undefined,
        displayType: TagValueDisplayType | null | undefined,
        format?: string | null,
    ): string | null | undefined {
        if (!value) {
            return value;
        }

        const numberValue = this.numberMappingService.mapStringToNumber(value);
        if (numberValue === undefined) {
            return value;
        }

        switch (displayType) {
            case TagValueDisplayType.NumberDecimal:
                if (!format) {
                    return this.numberMappingService.mapNumberToFormattedString(Math.round(numberValue), undefined, true);
                }

                return this.numberMappingService.mapNumberToFormattedString(numberValue, format, true);
            case TagValueDisplayType.Number:
            case TagValueDisplayType.Currency:
                return this.numberMappingService.mapNumberToFormattedString(numberValue, format, true);
            case TagValueDisplayType.SizeInBytes:
                return this.numberMappingService.mapToFileSizeString(numberValue, false, true);
            default:
                return this.numberMappingService.mapNumberToFormattedString(numberValue, undefined, true);
        }
    }
}
